module.exports = __webpack_public_path__ + "img/htn_hustletokens.34b7336.png";